/** Extra minute added over the elapsed time to absorb clock skew / latency. */
export const PRINT_CATCHUP_GRACE_MS = 60 * 1000;

/** Floor: always look back at least this much (covers quick restarts). */
export const PRINT_CATCHUP_MIN_WINDOW_MINUTES = 15;

/**
 * Cap: never look back further than this, so long offline periods don't
 * cause paper spam. Orders older than the window are left alone.
 */
export const PRINT_CATCHUP_MAX_WINDOW_MINUTES = 4 * 60;

/**
 * Window (in minutes) that the print catch-up reconciliation should fetch,
 * based on the last moment the print pipeline was known to be healthy.
 * A falsy `lastPrintSyncAt` (fresh device) yields the minimum window.
 */
export function computePrintCatchUpWindowMinutes({
  lastPrintSyncAt,
  now,
}: {
  lastPrintSyncAt: number;
  now: number;
}): number {
  const elapsedMs = lastPrintSyncAt
    ? now - lastPrintSyncAt + PRINT_CATCHUP_GRACE_MS
    : 0;

  return Math.min(
    PRINT_CATCHUP_MAX_WINDOW_MINUTES,
    Math.max(PRINT_CATCHUP_MIN_WINDOW_MINUTES, Math.ceil(elapsedMs / 60000))
  );
}
